import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { pushNotificationService } from '../services/pushNotificationService';

export const usePushNotifications = () => {
  const navigate = useNavigate();

  const initializePushNotifications = useCallback(async () => {
    if (pushNotificationService.isAvailable()) {
      await pushNotificationService.initialize();
    }
  }, []);

  const handleNotificationAction = useCallback((event: CustomEvent) => {
    const { actionUrl, notificationId, type } = event.detail;
    
    console.log('Handling notification action:', { actionUrl, notificationId, type });
    
    // Navigate to the action URL
    if (actionUrl) {
      navigate(actionUrl);
    }
  }, [navigate]);

  const handleNotificationReceived = useCallback((event: CustomEvent) => {
    const notification = event.detail;
    console.log('Notification received:', notification);
    
    // You can show a toast notification here or update UI
    // For now, we'll just log it
  }, []);

  useEffect(() => {
    // Initialize push notifications when the hook is used
    initializePushNotifications();

    // Set up event listeners for custom events
    const handleAction = (event: CustomEvent) => handleNotificationAction(event);
    const handleReceived = (event: CustomEvent) => handleNotificationReceived(event);

    window.addEventListener('push-notification-action', handleAction as EventListener);
    window.addEventListener('push-notification-received', handleReceived as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('push-notification-action', handleAction as EventListener);
      window.removeEventListener('push-notification-received', handleReceived as EventListener);
    };
  }, [initializePushNotifications, handleNotificationAction, handleNotificationReceived]);

  return {
    initializePushNotifications,
    isAvailable: pushNotificationService.isAvailable(),
  };
};
